export default __webpack_public_path__ + "static/media/welcome-home-screen.efff6136.png";